const purchaseServiceStatus = Object.freeze({
  Draft: 1,
  Submitted: 2,
  UnderReview: 3,
  Approved: 4,
  Signed: 5,
  Returned: 6,
  Rejected: 7,
  Determined: 8,
  Awarded: 9,
});

export const purchaseServiceStatusColor = Object.freeze({
  Draft: '#B5C3BC',
  Submitted: '#FAE76F',
  UnderReview: '#F8B184',
  Approved: '#2DB782',
  Signed: '#A3E5B3',
  Returned: '#D5B89A',
  Rejected: '#c9545e',
  Determined: '#F8B184',
});

export default purchaseServiceStatus;
